export class Product {
  code: string
  subject: string
  knum: string
  title: string
  desc: string
  enable: boolean

  constructor(
    code: string,
    subject: string,
    knum: string,
    title: string,
    desc: string,
    enable: boolean
  ) {
    this.code = code
    this.subject = subject
    this.knum = knum
    this.title = title
    this.desc = desc
    this.enable = enable
  }

  get knums(): string[] {
    return this.knum.split('／')
  }

  get titles(): string[] {
    return this.title.split('／')
  }
}

export class SubjectProducts {
  subject: string
  products: Array<Product>

  constructor(subject: string) {
    this.subject = subject
    this.products = []
  }
}
